import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { MODES } from 'components/CreateUpdateSiteModal/interface'
import { addUpgradeReason } from 'utils/general'

/**
 * Generic access/display mode dropdown row.
 * - trial: click upgrades instead of selecting
 * - selectable=false: click calls onIntercept instead of selecting
 */
const SelectItem = ({
  label,
  name,
  trial = false,
  learnLink,
  onUpgrade,
  description,
  selectable = true,
  onIntercept
}) => {
  const canSelect = selectable && !trial

  const handleClick = (e) => {
    if (e.target.tagName === 'A') return

    if (trial) {
      e.preventDefault()
      e.stopPropagation()
      addUpgradeReason(label)
      onUpgrade?.()
      return
    }

    if (!selectable) {
      e.preventDefault()
      e.stopPropagation()
      onIntercept?.()
    }
  }

  return (
    <Dropdown.Item
      className="flex pt-2 pb-2 white-space-wrap"
      eventKey={canSelect ? label : undefined}
      onClick={handleClick}
    >
      <img className="me-3 mt-1" src={`/assets/icons/${MODES[label].icon}`} width={20} alt="" />
      <div>
        <div>
          {name || label}
          {trial && learnLink && (
            <div className="d-inline ms-2 op-6">
              <a
                href={learnLink}
                target="_blank"
                className="ms-1 text-decoration-underline font-small black"
                rel="noreferrer"
              >
                Learn more
              </a>
            </div>
          )}
        </div>
        <div className="font-small grey">{description || MODES[label].desc}</div>
      </div>
    </Dropdown.Item>
  )
}

export default SelectItem
